import { create } from 'apisauce'

// define the api
const api = create({
  baseURL: process.env.VUE_APP_SERVER_URL || "http://localhost:3000",
  headers: { "content-type": "text/plain" },
});

export default api;
